import { createContext, useContext } from 'react';
import { AlertColor } from '@mui/material';

// Define the context type
export interface ToastContextType {
  showToast: (message: string, severity: AlertColor) => void;
}

// Create the context
export const ToastContext = createContext<ToastContextType | undefined>(undefined);

// Create the hook
export const useToast = (): ToastContextType => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
